<template>
    <div>

                    <div style="" class="reveal text-container text-center center-horizontal">
                        <!--                <div class="py-10"></div>-->


                        <div class="mx-5 pt-5 pb-5 center-vertical center-horizontal teacher-verify-small-card"
                             style="">
                            <div class="teacher-verify-circle center-horizontal center-vertical"
                                 style="background-color: rgba(162, 9, 22, 0.2); ">
                                1
                            </div>
                            <div class="py-2"></div>
                            <div style="font-size: 13px">지원서류 <span style="font-weight: bold">평가</span></div>
                        </div>

            </div>
        </div>

</template>

<script>
    export default {
        name: "TeacherVerify2",
        mounted() {
            window.addEventListener("scroll", this.reveal);
        },
        destroyed() {
            window.removeEventListener("scroll", this.reveal);
        },
        methods: {
            reveal() {
                var reveals = document.querySelectorAll(".reveal");

                for (var i = 0; i < reveals.length; i++) {
                    var windowHeight = window.innerHeight;
                    var elementTop = reveals[i].getBoundingClientRect().top;
                    var elementVisible = 150;

                    if (elementTop < windowHeight - elementVisible) {
                        reveals[i].classList.add("active");
                    } else {
                        reveals[i].classList.remove("active");
                    }
                }
            },
        },
    };
</script>

<style>


    body {
        /*background: #42455a;*/
    }

    section {
        /*min-height: 100vh;*/
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
    }

    .each-title {
        font-size: 21px !important;
        text-align: left !important;
    }

    section:nth-child(1) {
        color: black;
    }

    section:nth-child(2) {
        color: black;
        background: #ffffff !important;
    }

    /* Add more styles for other sections as needed */
    section .container {
        /*margin: 100px;*/
        background-color: #ffffff !important;

    }

    section h1 {
        /*font-size: 3rem;*/
        /*margin: 20px;*/
    }

    section h2 {
        font-size: 40px;
        /*text-align: center;*/
        text-transform: uppercase;
    }

    section .text-container {
        display: flex;
        /*padding: 20px;*/
        /*margin-top: 10px;*/
    }

    section .text-container .text-box {
        /*margin: 20px;*/
        /*padding: 20px;*/
        /*background: #00c2cb;*/

    }

    section .text-container .text-box h3 {
        font-size: 30px;
        /*text-align: center;*/
        text-transform: uppercase;
        /*margin-bottom: 10px;*/
    }

    @media (max-width: 900px) {
        section h1 {
            font-size: 2rem;
            /*text-align: center;*/
        }

        section .text-container {
            flex-direction: column;
        }
    }

    .reveal {
        position: relative;
        transform: translateY(150px);
        opacity: 0;
        transition: 1s all ease;
    }

    .reveal.active {
        transform: translateY(0);
        opacity: 1;
    }
    .center-horizontal {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .center-vertical {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .vertical-line {
        width: 2px; /* Adjust the width of the vertical line */
        height: 7px; /* Adjust the height of the vertical line */
        background-color: white; /* Change the color of the vertical line */
    }

    .short-vertical-line {
        width: 2px; /* Adjust the width of the vertical line */
        height: 2px; /* Adjust the height of the vertical line */
        background-color: white; /* Change the color of the vertical line */
    }

    .short-vertical-line-3 {
        width: 2px; /* Adjust the width of the vertical line */
        height: 2px; /* Adjust the height of the vertical line */
        background-color: #ecced04d; /* Change the color of the vertical line */
    }

    .vertical-line-2 {
        width: 2px; /* Adjust the width of the vertical line */
        height: 7px; /* Adjust the height of the vertical line */
        background-color: #ecced07d; /* Change the color of the vertical line */
    }

    .short-vertical-line-2 {
        width: 2px; /* Adjust the width of the vertical line */
        height: 2px; /* Adjust the height of the vertical line */
        background-color: #ecced07d; /* Change the color of the vertical line */
    }

</style>

